import React from 'react';
import './Asistencia.css';
import HeaderComponent from '../../components/Asistencias/Header/Header';
import AsistenciaComponent from '../../components/Asistencias/Asistencia/Asistencia';

const Asistencia = () => {
    return (
      <div className= "contenedor-derecho-prefectos fade-in">
        <div>
            <HeaderComponent />
        </div>
        <div>
            <AsistenciaComponent />
        </div>
      </div>
    );
  };
  
export default Asistencia;

